import type { DateTime } from 'luxon';
import React from 'react';
import styled from 'styled-components';
import { useCountdown } from '../../../../../../../hooks';
import { Container } from '../container';
import { Timer } from './timer';

const StyledCountdown = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  position: relative;
  z-index: 2;

  > div {
    background-color: rgba(0, 0, 0, 0.7);
  }

  > .titleblock {
    max-width: 210px;

    .x-viewport-md & {
      max-width: 450px;
    }
  }

  .title {
    font-size: 14px;
    line-height: 1.4;
  }

  .subtitle {
    font-size: 12px;
  }

  .x-viewport-md & {
    max-width: 450px;
    padding: 12px;

    .title {
      font-size: 24px;
    }
    .subtitle {
      font-size: 16px;
    }
  }
`;

export const Countdown = ({
  scheduledTime
}: {
  scheduledTime: DateTime;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
}): React.ReactElement => {
  const countdown = useCountdown(scheduledTime);

  return (
    <StyledCountdown>
      <Container className='text-center titleblock'>
        {countdown.complete && (
          <div className='title lineclamp-3 mb-12px'>Your event is about to begin</div>
        )}
        <div className='subtitle text-uppercase'>{scheduledTime.toFormat('LLLL d, y h:mm a')}</div>
      </Container>
      {!countdown.complete ? (
        <Container className='mt-12px'>
          <Timer {...countdown} />
        </Container>
      ) : null}
    </StyledCountdown>
  );
};
